import {
  CUSTOM_ELEMENTS_SCHEMA,
  LOCALE_ID,
  NgModule,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateFnsAdapter, MAT_DATE_FNS_FORMATS } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { it } from 'date-fns/locale';
import { NgChartsModule } from 'ng2-charts';
import { NG_SCROLLBAR_OPTIONS, NgScrollbarModule } from 'ngx-scrollbar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DialogAlertComponent } from './components/dialog-alert/dialog-alert.component';
import { DialogFiltroGenericoComponent } from './components/dialog-filtro-generico/dialog-filtro-generico.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { ListaAziendeComponent } from './components/lista-aziende/lista-aziende.component';
import { ListaTabellareSempliceComponent } from './components/lista-tabellare-semplice/lista-tabellare-semplice.component';
import { DialogFiltroTabellareComponent } from './components/lista-tabellare/dialog/dialog-filtro-tabellare/dialog-filtro-tabellare.component';
import { ListaTabellareComponent } from './components/lista-tabellare/lista-tabellare.component';
import { ListaUtentiComponent } from './components/lista-utenti/lista-utenti.component';
import { SelezionaStakeholdersComponent } from './components/materialita/seleziona-stakeholders/seleziona-stakeholders.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SeparatoreLabelComponent } from './components/separatore-label/separatore-label.component';
import { TitoloSubtitoloComponent } from './components/titolo-subtitolo/titolo-subtitolo.component';
import { WidgetDashboardBarComponent } from './components/widget-dashboard-bar/widget-dashboard-bar.component';
import { WidgetDashboardChartComponent } from './components/widget-dashboard-chart/widget-dashboard-chart.component';
import { FormContainerDirective } from './directives/forms/form-container.directive';
import { FormElementDirective } from './directives/forms/form-element.directive';
import { FormErrorDirective } from './directives/forms/form-error.directive';
import { MaterialModule } from './modules/material/material.module';
import { DialogCreaMaterialitaComponent } from './page/analisi-materialita/materialita/dialog/dialog-crea-materialita/dialog-crea-materialita.component';
import { DialogCreaTemplateMailComponent } from './page/analisi-materialita/materialita/dialog/dialog-crea-template-mail/dialog-crea-template-mail.component';
import { MaterialitaComponent } from './page/analisi-materialita/materialita/materialita.component';
import { DialogCreaStakeholderComponent } from './page/analisi-materialita/stakeholder/dialog/dialog-crea-stakeholder/dialog-crea-stakeholder.component';
import { StakeholderComponent } from './page/analisi-materialita/stakeholder/stakeholder.component';
import { AutovalutazioniComponent } from './page/autovalutazioni/autovalutazioni.component';
import { AziendeComponent } from './page/aziende/aziende.component';
import { DialogCreaAziendaComponent } from './page/aziende/dialog/dialog-crea-azienda/dialog-crea-azienda.component';
import { DialogVisUtenteComponent } from './page/aziende/dialog/dialog-vis-utente/dialog-vis-utente.component';
import { CfgAmbitiComponent } from './page/configurazioni/cfg-ambiti/cfg-ambiti.component';
import { DialogCreaAmbitoComponent } from './page/configurazioni/cfg-ambiti/dialog/dialog-crea-ambito/dialog-crea-ambito.component';
import { CfgAutovalutazioniComponent } from './page/configurazioni/cfg-autovalutazioni/cfg-autovalutazioni.component';
import { DialogAnteprimaComponent } from './page/configurazioni/cfg-autovalutazioni/dialog/dialog-anteprima/dialog-anteprima.component';
import { DialogCreaCfgAutovalutazioneComponent } from './page/configurazioni/cfg-autovalutazioni/dialog/dialog-crea-cfg-autovalutazione/dialog-crea-cfg-autovalutazione.component';
import { CfgCategorieStakeholderComponent } from './page/configurazioni/cfg-categorie-stakeholder/cfg-categorie-stakeholder.component';
import { DialogCreaCategoriaStakeholderComponent } from './page/configurazioni/cfg-categorie-stakeholder/dialog/dialog-crea-categoria-stakeholder/dialog-crea-categoria-stakeholder.component';
import { CfgImpattiComponent } from './page/configurazioni/cfg-impatti/cfg-impatti.component';
import { DialogCreaCfgImpattoComponent } from './page/configurazioni/cfg-impatti/dialog/dialog-crea-cfg-impatto/dialog-crea-cfg-impatto.component';
import { CfgScritturaImpattoComponent } from './page/configurazioni/cfg-scrittura-impatto/cfg-scrittura-impatto/cfg-scrittura-impatto.component';
import { CfgSettoriComponent } from './page/configurazioni/cfg-settori/cfg-settori.component';
import { DialogCreaCfgSettoriComponent } from './page/configurazioni/cfg-settori/dialog/dialog-crea-cfg-settori/dialog-crea-cfg-settori.component';
import { CfgTematicheComponent } from './page/configurazioni/cfg-tematiche/cfg-tematiche.component';
import { DialogCreaCfgTematicaComponent } from './page/configurazioni/cfg-tematiche/dialog/dialog-crea-cfg-tematica/dialog-crea-cfg-tematica.component';
import { DashboardAziendaComponent } from './page/dashboard-azienda/dashboard-azienda.component';
import { HomeComponent } from './page/home/home.component';
import { LoginComponent } from './page/login/login.component';
import { StatisticheComponent } from './page/statistiche/statistiche.component';
import { DialogCreaUtentiComponent } from './page/utenti/dialog/dialog-crea-utenti/dialog-crea-utenti.component';
import { DialogVisAziendeComponent } from './page/utenti/dialog/dialog-vis-aziende/dialog-vis-aziende.component';
import { UtentiComponent } from './page/utenti/utenti.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { NgOptimizedImage, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { WidgetComponent } from '@zcs/agent-chat-widget';
import { StarRatingConfigService, StarRatingModule } from 'angular-star-rating';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DragAndDropFilesDirective } from 'src/app/directives/directives/drag-and-drop-files.directive';
import { BannerManutenzioneComponent } from './banner-manutenzione/banner-manutenzione.component';
import { AnalisiRisultatiComponent } from './components/analisi-risultati/analisi-risultati.component';
import { DialogImpostaEsclusioniComponent } from './components/analisi-risultati/dialog/dialog-imposta-esclusioni/dialog-imposta-esclusioni.component';
import { AnteprimaSurveyComponent } from './components/anteprima-survey/anteprima-survey.component';
import { AppFolliaWidgetComponent } from './components/app-follia-widget/app-follia-widget.component';
import { AutocompleteComponent } from './components/autocomplete/autocomplete.component';
import { BottomSheetAlertComponent } from './components/bottom-sheet-alert/bottom-sheet-alert.component';
import { CfgQuestionarioComponent } from './components/cfg-questionario/cfg-questionario.component';
import { DialogMotivazioneNonApplicabilitaComponent } from './components/cfg-questionario/dialog-motivazione-non-applicabilita/dialog-motivazione-non-applicabilita.component';
import { DialogSurveyCheckEsrsComponent } from './components/cfg-questionario/dialog-survey-check-esrs/dialog-survey-check-esrs.component';
import { CfgStampaComponent } from './components/cfg-stampa/cfg-stampa.component';
import { CompilaAutovalutazioneComponent } from './components/compila-autovalutazione/compila-autovalutazione.component';
import { CompilaInformativaAziendaleComponent } from './components/compila-informativa-aziendale/compila-informativa-aziendale.component';
import { CompilaRisposteTematicheComponent } from './components/compila-risposte-tematiche/compila-risposte-tematiche.component';
import { CompilaSintesiSostenibilitaComponent } from './components/compila-sintesi-sostenibilita/compila-sintesi-sostenibilita.component';
import { CustomSnackbarComponent } from './components/custom-snackbar/custom-snackbar.component';
import { DialogPromptAiComponent } from './components/dialog-prompt-ai/dialog-prompt-ai.component';
import { DialogSelezioneDocumentiPerAiComponent } from './components/dialog-selezione-documenti-per-ai/dialog-selezione-documenti-per-ai.component';
import { DragDropFileUploaderComponent } from './components/drag-drop-file-uploader/drag-drop-file-uploader.component';
import { EditorComponent } from './components/editor/editor.component';
import { FolliaIconForElementComponent } from './components/follia-icon-for-element/follia-icon-for-element.component';
import { InclusioneModuliComponent } from './components/inclusione-moduli/inclusione-moduli.component';
import { DialogSceltaCampioneComponent } from './components/materialita/seleziona-stakeholders/dialog-scelta-campione/dialog-scelta-campione.component';
import { MyRatingStarComponent } from './components/my-rating-star/my-rating-star.component';
import { ProgressBarOverlayComponent } from './components/progress-bar-overlay/progress-bar-overlay.component';
import { RadioGroupComponent } from './components/radio-group/radio-group.component';
import { SelectCustomComponent } from './components/select-custom/select-custom.component';
import { BottomSheetInfoElementiComponent } from './components/selezione-elementi-questionario/bottom-sheet-info-elementi/bottom-sheet-info-elementi.component';
import { DialogAssociaFiguraAziendaleComponent } from './components/selezione-elementi-questionario/dialog/dialog-associa-figura-aziendale/dialog-associa-figura-aziendale.component';
import { SelezioneAzioniBuonepraticheBilancioComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-azioni-buonepratiche-bilancio/selezione-azioni-buonepratiche-bilancio.component';
import { SelezioneAzioniBuonepratichePolicyComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-azioni-buonepratiche-policy/selezione-azioni-buonepratiche-policy.component';
import { SelezioneAzioniBuonepraticheSintesiComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-azioni-buonepratiche-sintesi/selezione-azioni-buonepratiche-sintesi.component';
import { SelezioneCertificazioniBilancioComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-certificazioni-bilancio/selezione-certificazioni-bilancio.component';
import { SelezioneCertificazioniPolicyComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-certificazioni-policy/selezione-certificazioni-policy.component';
import { SelezioneCertificazioniSintesiComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-certificazioni-sintesi/selezione-certificazioni-sintesi.component';
import { SelezioneImpattiBilancioComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-impatti-bilancio/selezione-impatti-bilancio.component';
import { SelezioneImpattiMaterialitaComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-impatti-materialita/selezione-impatti-materialita.component';
import { SelezioneImpegniBilancioComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-impegni-bilancio/selezione-impegni-bilancio.component';
import { SelezioneImpegniPolicyComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-impegni-policy/selezione-impegni-policy.component';
import { SelezioneImpegniSintesiComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-impegni-sintesi/selezione-impegni-sintesi.component';
import { SelezioneKpiBilancioComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-kpi-bilancio/selezione-kpi-bilancio.component';
import { SelezioneKPISintesiComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-kpi-sintesi/selezione-kpi-sintesi.component';
import { SelezioneObiettiviPianoComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-obiettivi-piano/selezione-obiettivi-piano.component';
import { SelezioneObiettiviTargetPianoComponent } from './components/selezione-elementi-questionario/metodi-selezione/selezione-obiettivi-target-piano/selezione-obiettivi-target-piano.component';
import { SelezioneElementiQuestionarioComponent } from './components/selezione-elementi-questionario/selezione-elementi-questionario.component';
import { SpinnerOverlayComponent } from './components/spinner-overlay/spinner-overlay.component';
import { StorageChartComponent } from './components/storage-chart/storage-chart.component';
import { EditTabellaDinamicaBottomSheetComponent } from './components/tabella-cfg-dinamica/edit-tabella-dinamica-bottom-sheet/edit-tabella-dinamica-bottom-sheet.component';
import { TabellaCfgDinamicaComponent } from './components/tabella-cfg-dinamica/tabella-cfg-dinamica.component';
import { TotaliCruscottoComponent } from './components/totali-cruscotto/totali-cruscotto.component';
import { TooltipOverlayDirective } from './directives/forms/tooltip-overlay.directive';
import { InputNumberDirective } from './directives/input-number.directive';
import { NotificationsComponent } from './notifications/notifications.component';
import { AnteprimaValidazioneIroComponent } from './page/analisi-materialita/doppia-materialita/anteprima-validazione-iro/anteprima-validazione-iro.component';
import { AssegnazioneIroComponent } from './page/analisi-materialita/doppia-materialita/assegnazione-iro/assegnazione-iro.component';
import { DialogAssegnaCategoriaIroComponent } from './page/analisi-materialita/doppia-materialita/assegnazione-iro/dialog-assegna-categoria-iro/dialog-assegna-categoria-iro.component';
import { DialogCriterioAssegnazioneComponent } from './page/analisi-materialita/doppia-materialita/assegnazione-iro/dialog-criterio-assegnazione/dialog-criterio-assegnazione.component';
import { DialogAnteprimaValidazioneIroComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-anteprima-validazione-iro/dialog-anteprima-validazione-iro.component';
import { DialogCreaDoppiaMaterialitaComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-crea-doppia-materialita/dialog-crea-doppia-materialita.component';
import { TooltipVariabiliIroComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-crea-doppia-materialita/tooltip-variabili-iro/tooltip-variabili-iro.component';
import { DialogCreaIroComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-crea-iro/dialog-crea-iro.component';
import { AnteprimaDoppiaMaterialitaSuveyComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-doppia-materialita-compila-survey/anteprima-doppia-materialita-suvey/anteprima-doppia-materialita-suvey.component';
import { DialogDoppiaMaterialitaCompilaSurveyComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-doppia-materialita-compila-survey/dialog-doppia-materialita-compila-survey.component';
import { DoppiaSurveyEsternaComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-doppia-materialita-compila-survey/doppia-survey-esterna/doppia-survey-esterna.component';
import { DialogSelezioneIroDoppiaMatComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-selezione-iro-doppia-mat/dialog-selezione-iro-doppia-mat.component';
import { DialogVisualValidazioniIroComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-visual-validazioni-iro/dialog-visual-validazioni-iro.component';
import { DoppiaMaterialitaComponent } from './page/analisi-materialita/doppia-materialita/doppia-materialita.component';
import { DialogAnteprimaSurveyComponent } from './page/analisi-materialita/materialita/dialog/dialog-anteprima-survey/dialog-anteprima-survey.component';
import { DialogInviaMailComponent } from './page/analisi-materialita/materialita/dialog/dialog-crea-template-mail/dialog-invia-mail/dialog-invia-mail.component';
import { DialogImportazioneExcelComponent } from './page/analisi-materialita/stakeholder/dialog/dialog-importazione-excel/dialog-importazione-excel.component';
import { DialogRiepilogoInvioMailComponent } from './page/analisi-materialita/doppia-materialita/dialog/dialog-riepilogo-invio-mail/dialog-riepilogo-invio-mail.component';
import { AutovalutazioneEsternoComponent } from './page/autovalutazione-esterno/autovalutazione-esterno.component';
import { DialogCompilaAutovalutazioneComponent } from './page/autovalutazioni/dialog/dialog-compila-autovalutazione/dialog-compila-autovalutazione.component';
import { DialogCreaAutovalutazioneComponent } from './page/autovalutazioni/dialog/dialog-crea-autovalutazione/dialog-crea-autovalutazione.component';
import { InfoFormVsmeComponent } from './page/aziende/dialog/dialog-crea-azienda/info-form-vsme/info-form-vsme.component';
import { DialogCreaFigureAziendeComponent } from './page/aziende/figure-aziende/dialog/dialog-crea-figure-aziende/dialog-crea-figure-aziende.component';
import { FigureAziendeComponent } from './page/aziende/figure-aziende/figure-aziende.component';
import { BilancioSostebilitaComponent } from './page/bilancio-sostebilita/bilancio-sostebilita.component';
import { DialogCreaBilancioSostenibilitaComponent } from './page/bilancio-sostebilita/dialog/dialog-crea-bilancio-sostenibilita/dialog-crea-bilancio-sostenibilita.component';
import { DialogEditDescrizioneIndiceComponent } from './page/bilancio-sostebilita/dialog/dialog-edit-descrizione-indice/dialog-edit-descrizione-indice.component';
import { BilancioSostenibilitaEsternaComponent } from './page/bilancio-sostenibilita-esterna/bilancio-sostenibilita-esterna.component';
import { BucketDocumentiComponent } from './page/bucket-documenti/bucket-documenti.component';
import { BreadcrumbFolderTreeComponent } from './page/bucket-documenti/documenti-components/breadcrumb-folder-tree/breadcrumb-folder-tree.component';
import { DialogCreaCartellaComponent } from './page/bucket-documenti/documenti-components/dialog-crea-cartella/dialog-crea-cartella.component';
import { DialogInfoDocumentoComponent } from './page/bucket-documenti/documenti-components/dialog-crea-cartella/dialog-info-documento/dialog-info-documento.component';
import { DialogReplaceFileComponent } from './page/bucket-documenti/documenti-components/dialog-replace-file/dialog-replace-file.component';
import { DialogSpiegazioneGestioneDocumentaleComponent } from './page/bucket-documenti/documenti-components/dialog-spiegazione-gestione-documentale/dialog-spiegazione-gestione-documentale.component';
import { FileCardDocumentiComponent } from './page/bucket-documenti/documenti-components/file-card-documenti/file-card-documenti.component';
import { FolderTreeComponent } from './page/bucket-documenti/documenti-components/folder-tree/folder-tree.component';
import { ListaFileBucketComponent } from './page/bucket-documenti/documenti-components/lista-file-bucket/lista-file-bucket.component';
import { MenuFolderComponent } from './page/bucket-documenti/documenti-components/menu-folder/menu-folder.component';
import { SearchAndFiltriDocumentiComponent } from './page/bucket-documenti/documenti-components/search-and-filtri-documenti/search-and-filtri-documenti.component';
import { CfgAzioneEBuonaPraticaComponent } from './page/configurazioni/cfg-azione-e-buona-pratica/cfg-azione-e-buona-pratica.component';
import { DialogCreaCfgAzioneEBuonaPraticaComponent } from './page/configurazioni/cfg-azione-e-buona-pratica/dialog/dialog-crea-cfg-azione-e-buona-pratica/dialog-crea-cfg-azione-e-buona-pratica.component';
import { CfgCertificazioniComponent } from './page/configurazioni/cfg-certificazioni/cfg-certificazioni.component';
import { DialogCreaCertificazioniComponent } from './page/configurazioni/cfg-certificazioni/dialog/dialog-crea-certificazioni/dialog-crea-certificazioni.component';
import { CfgComitatiComponent } from './page/configurazioni/cfg-comitati/cfg-comitati.component';
import { DialogCreaComitatiComponent } from './page/configurazioni/cfg-comitati/dialog/dialog-crea-comitati/dialog-crea-comitati.component';
import { CfgDestinatariPolicyComponent } from './page/configurazioni/cfg-destinatari-policy/cfg-destinatari-policy.component';
import { DialogCreaDestinatariPolicyComponent } from './page/configurazioni/cfg-destinatari-policy/dialog/dialog-crea-destinatari-policy/dialog-crea-destinatari-policy.component';
import { CfgEsrsComponent } from './page/configurazioni/cfg-esrs/cfg-esrs.component';
import { CreaEsrsComponent } from './page/configurazioni/cfg-esrs/dialog/crea-esrs/crea-esrs.component';
import { DialogCreaESRSComponent } from './page/configurazioni/cfg-esrs/dialog/dialog-crea-esrs/dialog-crea-esrs.component';
import { DialogSelezionaImpattiDdComponent } from './page/configurazioni/cfg-esrs/dialog/dialog-seleziona-impatti-dd/dialog-seleziona-impatti-dd.component';
import { CfgGeneralPromptComponent } from './page/configurazioni/cfg-general-prompt/cfg-general-prompt.component';
import { CfgImpegniComponent } from './page/configurazioni/cfg-impegni/cfg-impegni.component';
import { DialogCreaImpegnoComponent } from './page/configurazioni/cfg-impegni/dialog/dialog-crea-impegno/dialog-crea-impegno.component';
import { CfgInformativaAziendaleComponent } from './page/configurazioni/cfg-informativa-aziendale/cfg-informativa-aziendale.component';
import { DialogAnteprimaCompilazioneInfoAzComponent } from './page/configurazioni/cfg-informativa-aziendale/dialog/dialog-anteprima-compilazione-info-az/dialog-anteprima-compilazione-info-az.component';
import { DialogCreaDomandeInformativaComponent } from './page/configurazioni/cfg-informativa-aziendale/dialog/dialog-crea-domande-informativa/dialog-crea-domande-informativa.component';
import { DialogCreaInformativaAziendaleComponent } from './page/configurazioni/cfg-informativa-aziendale/dialog/dialog-crea-informativa-aziendale/dialog-crea-informativa-aziendale.component';
import { DialogDdDomandeComponent } from './page/configurazioni/cfg-informativa-aziendale/dialog/dialog-dd-domande/dialog-dd-domande.component';
import { CfgKPIComponent } from './page/configurazioni/cfg-kpi/cfg-kpi.component';
import { DialogCreaKPIComponent } from './page/configurazioni/cfg-kpi/dialog/dialog-crea-kpi/dialog-crea-kpi.component';
import { DialogTarghetStdrComponent } from './page/configurazioni/cfg-kpi/dialog/dialog-targhet-stdr/dialog-targhet-stdr.component';
import { CfgLineeGuidaStampeComponent } from './page/configurazioni/cfg-linee-guida-stampe/cfg-linee-guida-stampe.component';
import { CfgModelliSviluppoPianoComponent } from './page/configurazioni/cfg-modelli-sviluppo-piano/cfg-modelli-sviluppo-piano.component';
import { DialogCreaCfgModelliSviluppoPianoComponent } from './page/configurazioni/cfg-modelli-sviluppo-piano/dialog-crea-cfg-modelli-sviluppo-piano/dialog-crea-cfg-modelli-sviluppo-piano.component';
import { CfgObiettiviAziendaliComponent } from './page/configurazioni/cfg-obiettivi-aziendali/cfg-obiettivi-aziendali.component';
import { DialogCreaObiettivoAziendaliComponent } from './page/configurazioni/cfg-obiettivi-aziendali/dialog/dialog-crea-obiettivo-aziendali/dialog-crea-obiettivo-aziendali.component';
import { CfgObiettiviPianoComponent } from './page/configurazioni/cfg-obiettivi-piano/cfg-obiettivi-piano.component';
import { DialogCreaObiettiviPianoComponent } from './page/configurazioni/cfg-obiettivi-piano/dialog/dialog-crea-obiettivi-piano/dialog-crea-obiettivi-piano.component';
import { CfgPerimetroApplicazionePolicyComponent } from './page/configurazioni/cfg-perimetro-applicazione-policy/cfg-perimetro-applicazione-policy.component';
import { DialogCreaPerimetroAppPolicyComponent } from './page/configurazioni/cfg-perimetro-applicazione-policy/dialog/dialog-crea-perimetro-app-policy/dialog-crea-perimetro-app-policy.component';
import { DialogSottoSettoriComponent } from './page/configurazioni/cfg-settori/dialog/dialog-sotto-settori/dialog-sotto-settori.component';
import { DialogCreaCfgSottoSettoriComponent } from './page/configurazioni/cfg-settori/dialog/dialog-sotto-settori/dialog/dialog-crea-cfg-sotto-settori/dialog-crea-cfg-sotto-settori.component';
import { CfgStandardRendicontazioneComponent } from './page/configurazioni/cfg-standard-rendicontazione/cfg-standard-rendicontazione.component';
import { DialogCreaStandardRendicontazioneComponent } from './page/configurazioni/cfg-standard-rendicontazione/dialog/dialog-crea-standard-rendicontazione/dialog-crea-standard-rendicontazione.component';
import { DialogCfgRisposteTematicaComponent } from './page/configurazioni/cfg-tematiche/dialog/dialog-crea-cfg-tematica/dialog-cfg-risposte-tematica/dialog-cfg-risposte-tematica.component';
import { DialogCheckEsrsComponent } from './page/configurazioni/cfg-tematiche/dialog/dialog-crea-cfg-tematica/dialog-check-esrs/dialog-check-esrs.component';
import { DialogCreaTabellaDinamicaComponent } from './page/configurazioni/cfg-tematiche/dialog/dialog-crea-cfg-tematica/dialog-crea-tabella-dinamica/dialog-crea-tabella-dinamica.component';
import { NormaVsmeBottomsheetComponent } from './page/configurazioni/cfg-tematiche/dialog/dialog-crea-cfg-tematica/norma-vsme-bottomsheet/norma-vsme-bottomsheet.component';
import { CfgUnitaDiMisuraComponent } from './page/configurazioni/cfg-unita-di-misura/cfg-unita-di-misura.component';
import { DialogCreaUnitaDiMisuraComponent } from './page/configurazioni/cfg-unita-di-misura/dialog/dialog-crea-unita-di-misura/dialog-crea-unita-di-misura.component';
import { DashboardComponent } from './page/dashboard/dashboard.component';
import { InformativaAziendaleEsternaComponent } from './page/informativa-aziendale-esterna/informativa-aziendale-esterna.component';
import { PasswordDimenticataComponent } from './page/password-dimenticata/password-dimenticata.component';
import { PianoSostenibilitaEsternaComponent } from './page/piano-sostenibilita-esterna/piano-sostenibilita-esterna.component';
import { DialogAssociaTargetObiettiviComponent } from './page/piano-sostenibilita/dialog/dialog-associa-target-obiettivi/dialog-associa-target-obiettivi.component';
import { DialogCreaPianoSostenibilitaComponent } from './page/piano-sostenibilita/dialog/dialog-crea-piano-sostenibilita/dialog-crea-piano-sostenibilita.component';
import { PianoSostenibilitaComponent } from './page/piano-sostenibilita/piano-sostenibilita.component';
import { PolicySostenibilitaEsternaComponent } from './page/policy-sostenibilita-esterna/policy-sostenibilita-esterna.component';
import { DialogCreaPolicySostenibilitaComponent } from './page/policy-sostenibilita/dialog/dialog-crea-policy-sostenibilita/dialog-crea-policy-sostenibilita.component';
import { CompilaComitatiComponent } from './page/policy-sostenibilita/dialog/seleziona-comitati/compila-comitati/compila-comitati.component';
import { SelezionaComitatiComponent } from './page/policy-sostenibilita/dialog/seleziona-comitati/seleziona-comitati.component';
import { CompilaPerimetriDestinatariComponent } from './page/policy-sostenibilita/dialog/seleziona-perimetro-destinatari/compila-perimetri-destinatari/compila-perimetri-destinatari.component';
import { SelezionaPerimetroDestinatariComponent } from './page/policy-sostenibilita/dialog/seleziona-perimetro-destinatari/seleziona-perimetro-destinatari.component';
import { PolicySostenibilitaComponent } from './page/policy-sostenibilita/policy-sostenibilita.component';
import { ReportVsmeEsternaComponent } from './page/report-vsme-esterna/report-vsme-esterna.component';
import { DialogCreaReportVsmeComponent } from './page/report-vsme/dialog/dialog-crea-report-vsme/dialog-crea-report-vsme.component';
import { ReportVsmeComponent } from './page/report-vsme/report-vsme.component';
import { ResetPasswordComponent } from './page/reset-password/reset-password.component';
import { SintesiSostenibilitaEsternaComponent } from './page/sintesi-sostenibilita-esterna/sintesi-sostenibilita-esterna.component';
import { DialogAssegnazioniComponent } from './page/sintesi-sostenibilita/dialog/dialog-assegnazioni/dialog-assegnazioni.component';
import { DialogCompilaSintesiSostenibilitaComponent } from './page/sintesi-sostenibilita/dialog/dialog-compila-sintesi-sostenibilita/dialog-compila-sintesi-sostenibilita.component';
import { DialogCompilazioneFigureComponent } from './page/sintesi-sostenibilita/dialog/dialog-compilazione-figure/dialog-compilazione-figure.component';
import { DialogCreaSintesiSostenibilitaComponent } from './page/sintesi-sostenibilita/dialog/dialog-crea-sintesi-sostenibilita/dialog-crea-sintesi-sostenibilita.component';
import { SintesiSostenibilitaComponent } from './page/sintesi-sostenibilita/sintesi-sostenibilita.component';
import { SurveyEsternoComponent } from './page/survey-esterno/survey-esterno.component';
import { DialogGestioneLicenzeComponent } from './page/utenti/dialog/dialog-gestione-licenze/dialog-gestione-licenze.component';
import { DialogRiepilogoLicenzeComponent } from './page/utenti/dialog/dialog-riepilogo-licenze/dialog-riepilogo-licenze.component';
import { DialogAttivazioniComponent } from './page/utenti/dialog/dialog-attivazioni/dialog-attivazioni.component';
import { DialogPacchettiAggiuntiviComponent } from './page/utenti/dialog/dialog-pacchetti-aggiuntivi/dialog-pacchetti-aggiuntivi.component';
import { GestioneLicenzeComponent } from './page/utenti/gestione-licenze/gestione-licenze.component';
import { RiepilogoLicenzeComponent } from './page/utenti/riepilogo-licenze/riepilogo-licenze.component';
import { ValidazioneIroEsternaComponent } from './page/validazione-iro-esterna/validazione-iro-esterna.component';
import { ByteFormatterPipe } from './pipes/byte-formatter.pipe';
import { FormatDatePipe } from './pipes/format-date.pipe';
import { JoinPipe } from './pipes/join.pipe';
import { NgStarRatingService } from './services/ng-star-rating/ng-star-rating.service';

import { ForceErrorViewDirective } from 'src/app/directives/force-error-view/force-error-view.directive';
import { AtecoSelectorComponent } from './components/ateco-selector/ateco-selector.component';
import { CompilaAssessmentComponent } from './components/compila-assessment/compila-assessment.component';
import { CompilaReportVsmeComponent } from './components/compila-report-vsme/compila-report-vsme.component';
import { MotivazioneRispostaVsmeComponent } from './components/motivazione-risposta-vsme/motivazione-risposta-vsme.component';

registerLocaleData(localeIt);

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    DashboardComponent,
    HomeComponent,
    WidgetDashboardBarComponent,
    WidgetDashboardChartComponent,
    AutovalutazioniComponent,
    StatisticheComponent,
    AziendeComponent,
    DashboardAziendaComponent,
    LineChartComponent,
    FormContainerDirective,
    FormElementDirective,
    SearchBarComponent,
    DialogCreaUtentiComponent,
    SeparatoreLabelComponent,
    TitoloSubtitoloComponent,
    FormElementDirective,
    ListaTabellareComponent,
    ListaTabellareSempliceComponent,
    DialogFiltroTabellareComponent,
    DialogCreaAziendaComponent,
    FormErrorDirective,
    CfgAutovalutazioniComponent,
    UtentiComponent,
    CfgAmbitiComponent,
    DialogCreaAmbitoComponent,
    DialogCreaCfgAutovalutazioneComponent,
    DialogAlertComponent,
    CfgTematicheComponent,
    DialogCreaCfgTematicaComponent,
    DialogAnteprimaComponent,
    DialogVisUtenteComponent,
    ListaUtentiComponent,
    DialogVisAziendeComponent,
    ListaAziendeComponent,
    CfgCategorieStakeholderComponent,
    StakeholderComponent,
    MaterialitaComponent,
    DialogCreaStakeholderComponent,
    DialogCreaCategoriaStakeholderComponent,
    DialogCreaMaterialitaComponent,
    CfgScritturaImpattoComponent,
    CfgImpattiComponent,
    DialogCreaCfgImpattoComponent,
    SelezionaStakeholdersComponent,
    DialogFiltroGenericoComponent,
    DialogCreaTemplateMailComponent,
    CfgSettoriComponent,
    DialogCreaCfgSettoriComponent,
    DialogAnteprimaSurveyComponent,
    MyRatingStarComponent,
    AnteprimaSurveyComponent,
    DialogImportazioneExcelComponent,
    SurveyEsternoComponent,
    AnalisiRisultatiComponent,
    DialogImpostaEsclusioniComponent,
    DialogImpostaEsclusioniComponent,
    FigureAziendeComponent,
    DialogCreaFigureAziendeComponent,
    SpinnerOverlayComponent,
    DialogCompilaAutovalutazioneComponent,
    CfgImpegniComponent,
    DialogCreaImpegnoComponent,
    CfgAzioneEBuonaPraticaComponent,
    DialogCreaCfgAzioneEBuonaPraticaComponent,
    DialogCreaAutovalutazioneComponent,
    CompilaAutovalutazioneComponent,
    SintesiSostenibilitaComponent,
    BilancioSostebilitaComponent,
    AutovalutazioneEsternoComponent,
    DialogCreaSintesiSostenibilitaComponent,
    CfgUnitaDiMisuraComponent,
    DialogCreaUnitaDiMisuraComponent,
    CfgKPIComponent,
    DialogCreaKPIComponent,
    SelezioneElementiQuestionarioComponent,
    SelezioneImpegniSintesiComponent,
    SelezioneAzioniBuonepraticheSintesiComponent,
    SelezioneKPISintesiComponent,
    DialogAssociaFiguraAziendaleComponent,
    PasswordDimenticataComponent,
    CfgQuestionarioComponent,
    DialogCompilazioneFigureComponent,
    DialogAssegnazioniComponent,
    DialogCompilaSintesiSostenibilitaComponent,
    CompilaSintesiSostenibilitaComponent,
    DialogCreaBilancioSostenibilitaComponent,
    SintesiSostenibilitaEsternaComponent,
    SelezioneImpattiBilancioComponent,
    SelezioneImpegniBilancioComponent,
    SelezioneAzioniBuonepraticheBilancioComponent,
    SelezioneKpiBilancioComponent,
    CfgInformativaAziendaleComponent,
    DialogCreaInformativaAziendaleComponent,
    DialogAnteprimaCompilazioneInfoAzComponent,
    CompilaInformativaAziendaleComponent,
    InformativaAziendaleEsternaComponent,
    CfgCertificazioniComponent,
    DialogCreaCertificazioniComponent,
    DialogInviaMailComponent,
    DialogRiepilogoInvioMailComponent,
    DialogTarghetStdrComponent,
    BilancioSostenibilitaEsternaComponent,
    AutocompleteComponent,
    DialogGestioneLicenzeComponent,
    EditorComponent,
    SelezioneImpattiMaterialitaComponent,
    SelezioneCertificazioniBilancioComponent,
    SelezioneCertificazioniSintesiComponent,
    DialogEditDescrizioneIndiceComponent,
    DialogSottoSettoriComponent,
    DialogCreaCfgSottoSettoriComponent,
    PolicySostenibilitaComponent,
    CfgComitatiComponent,
    CfgDestinatariPolicyComponent,
    CfgPerimetroApplicazionePolicyComponent,
    DialogCreaComitatiComponent,
    DialogCreaDestinatariPolicyComponent,
    DialogCreaPerimetroAppPolicyComponent,
    DialogCreaPolicySostenibilitaComponent,
    SelezioneImpegniPolicyComponent,
    SelezioneAzioniBuonepratichePolicyComponent,
    SelezioneCertificazioniPolicyComponent,
    SelezionaComitatiComponent,
    CompilaComitatiComponent,
    PolicySostenibilitaEsternaComponent,
    SelezionaPerimetroDestinatariComponent,
    CompilaPerimetriDestinatariComponent,
    CfgLineeGuidaStampeComponent,
    CfgStampaComponent,
    PianoSostenibilitaComponent,
    DialogCreaPianoSostenibilitaComponent,
    CfgObiettiviPianoComponent,
    DialogCreaObiettiviPianoComponent,
    SelezioneObiettiviPianoComponent,
    DialogAssociaTargetObiettiviComponent,
    SelezioneObiettiviTargetPianoComponent,
    PianoSostenibilitaEsternaComponent,
    CfgObiettiviAziendaliComponent,
    DialogCreaObiettivoAziendaliComponent,
    CfgModelliSviluppoPianoComponent,
    DialogCreaCfgModelliSviluppoPianoComponent,
    InputNumberDirective,
    GestioneLicenzeComponent,
    RiepilogoLicenzeComponent,
    DialogRiepilogoLicenzeComponent,
    DialogAttivazioniComponent,
    DialogPacchettiAggiuntiviComponent,
    CfgStandardRendicontazioneComponent,
    DialogCreaStandardRendicontazioneComponent,
    RadioGroupComponent,
    SelectCustomComponent,
    BottomSheetInfoElementiComponent,
    ResetPasswordComponent,
    DialogCfgRisposteTematicaComponent,
    CfgEsrsComponent,
    DialogCreaESRSComponent,
    CreaEsrsComponent,
    DialogSelezionaImpattiDdComponent,
    DoppiaMaterialitaComponent,
    DialogCreaDoppiaMaterialitaComponent,
    DialogCheckEsrsComponent,
    DialogSurveyCheckEsrsComponent,
    DialogSelezioneIroDoppiaMatComponent,
    DialogCreaIroComponent,
    DialogAnteprimaValidazioneIroComponent,
    AnteprimaValidazioneIroComponent,
    JoinPipe,
    ValidazioneIroEsternaComponent,
    DialogSceltaCampioneComponent,
    DialogVisualValidazioniIroComponent,
    AssegnazioneIroComponent,
    DialogAssegnaCategoriaIroComponent,
    DialogCriterioAssegnazioneComponent,
    DialogDoppiaMaterialitaCompilaSurveyComponent,
    AnteprimaDoppiaMaterialitaSuveyComponent,
    DoppiaSurveyEsternaComponent,
    BottomSheetAlertComponent,
    TooltipOverlayDirective,
    TooltipVariabiliIroComponent,
    DialogCreaDomandeInformativaComponent,
    DialogDdDomandeComponent,
    DialogCreaTabellaDinamicaComponent,
    TabellaCfgDinamicaComponent,
    EditTabellaDinamicaBottomSheetComponent,
    NormaVsmeBottomsheetComponent,
    ReportVsmeComponent,
    DialogCreaReportVsmeComponent,
    InfoFormVsmeComponent,
    DialogMotivazioneNonApplicabilitaComponent,
    CompilaRisposteTematicheComponent,
    ReportVsmeEsternaComponent,
    InclusioneModuliComponent,
    TotaliCruscottoComponent,
    BucketDocumentiComponent,
    FolderTreeComponent,
    ListaFileBucketComponent,
    DialogCreaCartellaComponent,
    StorageChartComponent,
    BreadcrumbFolderTreeComponent,
    BannerManutenzioneComponent,
    NotificationsComponent,
    AppFolliaWidgetComponent,
    MenuFolderComponent,
    DialogInfoDocumentoComponent,
    FormatDatePipe,
    ByteFormatterPipe,
    DialogReplaceFileComponent,
    ProgressBarOverlayComponent,
    SearchAndFiltriDocumentiComponent,
    CfgGeneralPromptComponent,
    DialogPromptAiComponent,
    DialogSelezioneDocumentiPerAiComponent,
    FileCardDocumentiComponent,
    FolliaIconForElementComponent,
    DialogSpiegazioneGestioneDocumentaleComponent,
    DragDropFileUploaderComponent,
    CustomSnackbarComponent,
    AtecoSelectorComponent,
    CompilaAssessmentComponent,
    CompilaReportVsmeComponent,
    MotivazioneRispostaVsmeComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatDividerModule,
    MatButtonModule,
    MatMenuModule,
    RouterModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgChartsModule,
    NgScrollbarModule,
    CKEditorModule,
    StarRatingModule.forRoot(),
    MatBottomSheetModule,
    NgxExtendedPdfViewerModule,
    OverlayModule,
    PortalModule,
    WidgetComponent,
    NgOptimizedImage,
    DragAndDropFilesDirective,
    ForceErrorViewDirective,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it-IT' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    { provide: MAT_DATE_LOCALE, useValue: it },
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_DATE_FNS_FORMATS },
    {
      provide: NG_SCROLLBAR_OPTIONS,
      useValue: {
        /* https://github.com/MurhafSousli/ngx-scrollbar/wiki/global-options */
      },
    },
    {
      provide: StarRatingConfigService,
      useClass: NgStarRatingService,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
